class CityHandler {
  constructor(localStorageService) {
    this.localStorageService = localStorageService;
    this.storageKey = "city";
    this.storageKeyAll = "cities";

    this.cities = null;
  }

  set(city) {
    this.localStorageService.set(this.storageKey, city);
  }

  get() {
    return this.localStorageService.get(this.storageKey);
  }

  setAll(cities) {
    this.cities = cities;
  }

  getAll() {
    return this.cities;
  }
  remove() {
    return this.localStorageService.remove(this.storageKey);
  }
}

export default CityHandler;



// WEBPACK FOOTER //
// ./src/services/cityHandler/cityHandler.service.js